import { configureStore } from "@reduxjs/toolkit";

import configSlice from "./config";
import facetsSlice from "./facets";
import overlaySlice from "./overlay";
import refinesSlice from "./refines";
import suggestionsSlice from "./suggestions";

const store = configureStore({
    reducer: {
        overlay: overlaySlice.reducer,
        config: configSlice.reducer,
        suggestions: suggestionsSlice.reducer,
        refines: refinesSlice.reducer,
        facets: facetsSlice.reducer,
    },
    devTools: process.env.NODE_ENV !== "production",
});

export const overlayActions = overlaySlice.actions;
export const configActions = configSlice.actions;
export const suggestionsActions = suggestionsSlice.actions;
export const refinesActions = refinesSlice.actions;
export const facetsActions = facetsSlice.actions;

export default store;
